import { toolInput } from "../tool-input";
import { SKILL_NAME_KEYS } from "./skill-call-constants";

/** The skill slug a loader call targets, or null when the input is unreadable. */
export function skillNameFromInput(input: unknown): string | null {
  if (!toolInput.isRecord(input)) {
    return null;
  }
  for (const key of SKILL_NAME_KEYS) {
    const value = input[key];
    if (typeof value === "string" && value.trim().length > 0) {
      // `command` may arrive as "dataviz some args": the slug is its head.
      // A plugin-namespaced `plugin:skill` stays whole.
      return value.trim().split(/\s+/u)[0] ?? null;
    }
  }
  return null;
}
